import React, { useContext, useEffect, useState, useMemo } from 'react'
import { Button, Dropdown, OverlayTrigger, Tab, Tabs, Tooltip } from 'react-bootstrap'
import Photo from '@resources/imgs/mask-group-2.png'
import { Link, useNavigate, useParams } from 'react-router-dom'
import History from './Tabs/History'
import Features from './Tabs/Features'
import General from './Tabs/General'
import Ask from './Tabs/Ask'
import Exams from './Tabs/Exams'
import Genetics from './Tabs/Genetics'
import LogoProssed from '@resources/imgs/logo-proseed.webp'
import '@resources/css/donator.css'
import CardSugestion from './../../components/SwiperSlide/CardSugestion'
import Share from '@resources/imgs/share.png'
import Header from '@components/Header/Header'
import Slider from 'react-slick'
import type { Settings } from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Lightbox from 'yet-another-react-lightbox'
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails'
import 'yet-another-react-lightbox/styles.css'
import 'yet-another-react-lightbox/plugins/thumbnails.css'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import * as $Donor from '@services/Donor'
import IDonor from '@interfaces/IDonor'
import LogoEuropean from '@resources/imgs/european.webp'
import LogoSeattle from '@resources/imgs/seattle.png'
import Ovulos from '@resources/imgs/tratament-2.png'
import Embriao from '@resources/imgs/tratament-1.png'
import Trompas from '@resources/imgs/tratament-3.png'
import { BsChevronRight } from 'react-icons/bs'
import New from '@resources/imgs/icon-new.svg'
import IDonorSuggestion from '@interfaces/IDonorSuggestion'
import LoadingSpinner from '@components/LoadingSpinner/LoadingSpinner'
import CatalogFooter from '@components/CatalogFooter/CatalogFooter'
import { displayOnProduction, downloadBlob } from '@helpers/Utils'
import { FaFilePdf, FaHeart, FaRegHeart, FaCheck, FaCamera, FaDna } from 'react-icons/fa'
import { FaTriangleExclamation } from 'react-icons/fa6'
import { TbBabyCarriage } from 'react-icons/tb'
import PdfLightbox from '@components/PdfLightbox/PdfLightbox'
import AuthContext from '@contexts/Auth'

const Donator: React.FC<any> = () => {
  const { onFavoriteDonor, user, onAddDonorToCart, cart, activeInProgressOrders } = useContext(AuthContext)

  const { id } = useParams()

  const [isLoading, setIsLoading] = useState(true)
  const [isLoadingFavorite, setIsLoadingFavorite] = useState(false)
  const [isLoadingDownload, setIsLoadingDownload] = useState(false)
  const [donor, setDonor] = useState<IDonor>({} as IDonor)
  const [donorSuggestions, setDonorSuggestions] = useState<IDonorSuggestion[]>([])
  const [lightboxOpen, setLightboxOpen] = useState(false)
  const [lightboxIndex, setLightboxIndex] = useState(0)
  const [pdfLightbox, setPdfLightbox] = useState<{ url: string; title?: string } | null>(null)

  const [bannerId, setBannerId] = useState(10)

  const donorId = donor?.internal_id ? String(donor.internal_id) : ''
  const isPatient = user?.roles?.some((role: any) => role.name === 'Paciente')
  const cartDonorIds = useMemo(() => cart?.donor_ids ? cart.donor_ids.split(',') : [], [cart?.donor_ids])
  const laudoGeneticoDoc = useMemo(() => donor?.genetics_documents?.find((doc) => doc.category?.toUpperCase() === 'LAUDO GENÉTICO'), [donor?.genetics_documents])
  const [isInCart, setIsInCart] = useState<boolean>(() => donorId ? cartDonorIds.includes(donorId) : false)

  useEffect(() => {
    if (!donorId) {
      setIsInCart(false)
      return
    }
    setIsInCart(cartDonorIds.includes(donorId))
  }, [cartDonorIds, donorId])

  useEffect(() => {
    const randomId = Math.floor(Math.random() * (18 - 10 + 1)) + 10
    setBannerId(randomId)
  }, [])

  const navigate = useNavigate()

  const SweetAlert = withReactContent(Swal)

  useEffect(() => {
    if (id) {
      setIsLoading(true)

      const params = {
        params: {
          include_suggestions: true
        }
      }

      $Donor.find(id, params).then(({ data: donor }) => {
        setDonor(donor)

        if (donor.suggestions) {
          setDonorSuggestions(donor.suggestions)
        }
      }).catch((error) => {
        let message = error.message || 'Erro ao buscar doador'

        if (error.response.status === 404) {
          message = 'Doador não encontrado'
        }

        SweetAlert.fire('Erro', message, 'error')

        navigate('/')
      }).finally(() => setIsLoading(false))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  const handleExportPdf = () => {
    if (!id) return

    setIsLoadingDownload(true)

    $Donor.pdf(id).then(({ data }) => {
      downloadBlob(data, `doador-${id}.pdf`)
    }).catch(() => {
      SweetAlert.fire({
        title: 'Erro ao gerar pdf',
        icon: 'error',
        text: 'Ocorreu um erro ao gerar o pdf. Tente novamente mais tarde.',
      })
    }).finally(() => setIsLoadingDownload(false))
  }

  const handleFavorite = () => {
    if (!id) return

    setIsLoadingFavorite(true)

    onFavoriteDonor(id, (isFavorited: boolean) => {
      setDonor((donor) => ({
        ...donor,
        is_favorited: isFavorited,
      }))
    }).finally(() => setIsLoadingFavorite(false))
  }

  const [mostrarSearchDonator, setMostrarSearchDonator] = useState(false)

  const handleBtnCartClick = () => {
    if (!donorId || isInCart) {
      return
    }

    onAddDonorToCart?.(donorId, (success) => {
      if (success) {
        setIsInCart(true)
      }
    })
  }

  const suggestionsCount = donorSuggestions.length
  const suggestionSliderSettings: Settings = {
    dots: true,
    infinite: true,
    speed: 200,
    slidesToShow: Math.min(2, Math.max(suggestionsCount, 1)),
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          slidesToShow: 1,
        }
      },
    ]
  }

  return (
    <>
      <div className="donator-page">
        <LoadingSpinner isLoading={isLoading} text="Buscando doador..." />
        <LoadingSpinner isLoading={isLoadingDownload} text="Baixando pdf..." />
        <LoadingSpinner isLoading={isLoadingFavorite} text="Atualizando favorito..." />

        <div className="container">
          <div className="row m-lg-0 align-items-center justify-content-between border-bottom pt-3 pb-4">
            <div className="col-6 col-sm-6 col-md-6 mb-0 d-none d-lg-block">
              <Link to="/">
                <img src={LogoProssed} alt="" className="img-fluid" />
              </Link>
            </div>
            <div className="col-12 col-lg-6 mb-0 px-0 px-lg-3">
              <Header />
            </div>
          </div>
          <div className="py-4">
            <div className="row m-0">
              <div className="col-auto pr-0">
                <a href="#" className="text-body d-flex align-items-center" onClick={() => navigate(-1)}>
                  Catálogo
                </a>
              </div>
              <div className="col-auto pl-1 pr-1">
                <BsChevronRight size={10} />
              </div>
              <div className="col-auto p-0">
                <a href="#" className="id d-flex align-items-center font-weight-bold">
                  Doador
                </a>
              </div>
              <div className="col-6">
                <div className="d-flex flex-column align-items-start">
                  <div className={`search-donator ${mostrarSearchDonator ? 'd-block' : 'd-none'}`}>
                  Buscar doador / <span>Doador {donor.internal_id}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-12 col-lg-7">
              <div className="user-box">
                <figure
                  className={`
                    banner mb-0
                    ${donor.photos && donor.photos.length > 0 ? (donor.photos.length <= 3 ? 'donor-has-photos few-photos' : 'donor-has-photos many-photos') : ''}
                  `}
                >
                  <img src={`https://picsum.photos/id/${bannerId}/770/225`} alt="" />
                </figure>
                <div className="profile-details">
                  <figure className="img-user">
                    <img src={donor.avatar || Photo} alt="" />
                    {donor?.is_new_donor ? (
                      <div className="icon-new">
                        <img src={New} alt="" />
                      </div>
                    ) : null}
                  </figure>
                  <div className="user-info-box">
                    <div className="user-info-id">
                      <div className="donator-details">
                        <h5>
                          ID: {`${donor.internal_id}` + (donor.nickname ? ` - ${donor.nickname}` : '')}
                        </h5>
                        <p className="mb-0">
                          {donor.age && (
                            `${donor.age} anos`
                          )}
                          {donor.age && donor?.sperm_bank?.name !== 'Pro-Seed' && (
                            <br />
                          )}
                          {donor.sperm_bank?.name !== 'Pro-Seed' && (
                            `${donor.donor_type}`
                          )}
                          <br />
                          <>{donor.sperm_bank?.name === 'Pro-Seed' ? 'Amostra Nacional' : 'Amostra Internacional'}</>
                        </p>
                      </div>
                      <div className="bank">
                        <figure className="mb-0 mb-lg-auto">
                          {donor.sperm_bank?.name === 'Pro-Seed' ? (
                            <img src={LogoProssed} alt="" className="sperm-bank-proseed" width={150} />
                          ) : donor.sperm_bank?.name === 'European Sperm Bank' ? (
                            <img src={LogoEuropean} alt="" width={150} />
                          ) : donor.sperm_bank?.name === 'Seattle Sperm Bank' ? (
                            <img src={LogoSeattle} alt="" width={150} />
                          ) : (
                            <img src={LogoProssed} alt="" width={150} />
                          )}
                        </figure>
                      </div>
                    </div>

                    <div className="d-flex flex-column flex-lg-row justify-content-between gap-10 my-0 my-lg-2">
                      {donor.photos && donor.photos.length > 0 && (
                        <div className="user-info-photos">
                          <OverlayTrigger placement="top" overlay={<Tooltip id="tt-photos-donor">Ver fotos do doador</Tooltip>}>
                            <button
                              className="btn btn-primary btn-photos d-flex px-2 align-items-center justify-content-center gap-10"
                              onClick={() => {
                                setLightboxIndex(0)
                                setLightboxOpen(true)
                              }}
                            >
                              <FaCamera size={16} />
                              Fotos do Doador
                            </button>
                          </OverlayTrigger>
                        </div>
                      )}

                      {donor.adult_photos && (
                        <div className="user-info-photos">
                          <OverlayTrigger placement="top" overlay={<Tooltip id="tt-adult-photos">Fotos quando adulto (PDF)</Tooltip>}>
                            <button
                              className="btn btn-primary btn-adult-photos d-flex px-2 align-items-center justify-content-center gap-10"
                              onClick={() => setPdfLightbox({ url: donor.adult_photos!, title: 'Fotos de Adulto' })}
                            >
                              <FaFilePdf size={16} />
                              <div className="d-flex flex-column align-items-start" style={{ lineHeight: '1.1' }}>
                                <small style={{ fontSize: '0.65rem', marginBottom: '-2px' }}>Acesso</small>
                                <span style={{ fontSize: '0.9rem' }}>Fotos de Adulto</span>
                              </div>
                            </button>
                          </OverlayTrigger>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-5">
              <div className="details">
                <div className="line-content">
                  <div className="content d-flex align-items-center justify-content-between">
                    <div className="result w-100">
                      <div className="title">
                        Amostras disponíveis para tratamento de:
                      </div>
                      {donor?.available_treatment_names && donor?.available_treatment_names?.length > 0 ? (
                        <div className="tratamentos d-flex pt-2 w-100">
                          {donor?.available_treatment_names.includes('ICSI') && donor.icsi_price ? (
                            <div className="d-flex col-4 p-0 flex-column align-items-center justify-content-center">
                              <div className="result d-flex align-items-center justify-content-center gap-5">
                                <img src={Ovulos} alt="" />
                                <span>ICSI</span>
                              </div>
                              <span className="treatment-values">R$ {donor.icsi_price}</span>
                            </div>
                          ) : null}
                          {donor?.available_treatment_names.includes('FIV') && donor.fiv_price ? (
                            <div className="d-flex col-4 p-0 flex-column align-items-center justify-content-center">
                              <div className="result d-flex align-items-center justify-content-center gap-5">
                                <img src={Embriao} alt="" />
                                <span>FIV</span>
                              </div>
                              <span className="treatment-values">R$ {donor.fiv_price}</span>
                            </div>
                          ) : null}
                          {donor?.available_treatment_names.includes('IIU') && donor.iiu_price ? (
                            <div className="d-flex col-4 p-0 flex-column align-items-center justify-content-center">
                              <div className="result d-flex align-items-center justify-content-center gap-5">
                                <img src={Trompas} alt="" />
                                <span>Inseminação</span>
                              </div>
                              <span className="treatment-values">R$ {donor.iiu_price}</span>
                            </div>
                          ) : null}
                        </div>
                      ) : (
                        <div className="tratamentos d-flex pt-2">
                          <div className="result d-flex px-1">
                            <span>Não disponível</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="line-content d-flex text-center justify-content-around">
                  <div className="content features">
                    <div className="title">
                      Cor da pele
                    </div>
                    <div className="result d-flex justify-content-center align-items-center">
                      <span>{donor?.skin_color?.name}</span>
                    </div>
                  </div>
                  <div className="content features">
                    <div className="title">
                      Cor dos olhos
                    </div>
                    <div className="result d-flex justify-content-center align-items-center">
                      {donor?.eye_color?.name}
                    </div>
                  </div>
                  <div className="content features">
                    <div className="title">
                      Cor do Cabelo
                    </div>
                    <div className="result d-flex justify-content-center align-items-center">
                      {donor?.hair_color?.name}
                    </div>
                  </div>
                  <div className="content features">
                    <div className="title">
                      Raça
                    </div>
                    <div className="result d-flex justify-content-center align-items-center">
                      {donor?.race?.name}
                    </div>
                  </div>
                </div>
                <div className="line-content d-flex text-center justify-content-around">
                  <div className="content features">
                    <div className="title text-center">
                      Tipo Sanguíneo
                    </div>
                    <div className="result d-flex justify-content-center align-items-center">
                      {donor?.blood_group?.name}
                    </div>
                  </div>
                  <div className="content features">
                    <div className="title">
                      Altura
                    </div>
                    <div className="result d-flex justify-content-center align-items-center">
                      {donor?.height}
                    </div>
                  </div>
                  <div className="content features">
                    <div className="title">
                      Peso
                    </div>
                    <div className="result d-flex justify-content-center align-items-center">
                      {donor?.weight}Kg
                    </div>
                  </div>
                  <div className="content features">
                    <div className="title">
                      Disponibilidade
                    </div>
                    <div className="result d-flex flex-column justify-content-center align-items-center">
                      Envio imediato
                      {(donor?.total_available_straws ?? 99) <= 2 && (
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tt-low-stock">Estoque baixo — restam poucas amostras</Tooltip>}>
                          <span className="low-stock-badge">
                            <FaTriangleExclamation /> Estoque Baixo
                          </span>
                        </OverlayTrigger>
                      )}
                    </div>
                  </div>
                </div>
                <div className="line-content">
                  <div className="content btns d-flex justify-content-end">
                    <div className="buttons d-flex justify-content-between">
                      {isPatient && displayOnProduction() && activeInProgressOrders.length < 1 && (
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tt-cart">{isInCart ? 'Já no carrinho' : 'Adicionar ao carrinho'}</Tooltip>}>
                          <button
                            className={`btn-cart btn btn-primary ${isInCart ? 'in-cart' : ''}`}
                            onClick={handleBtnCartClick}
                            disabled={isInCart}
                          >
                            <figure>
                              {isInCart ? (
                                <FaCheck size={22} className="cart-icon" />
                              ) : (
                                <TbBabyCarriage size={22} className="cart-icon" />
                              )}
                            </figure>
                          </button>
                        </OverlayTrigger>
                      )}
                      <button className={`btn btn-primary ${donor.is_favorited ? 'active' : ''}`} onClick={handleFavorite}>
                        {donor.is_favorited ? (
                          <OverlayTrigger placement="top" overlay={<Tooltip id="favorite-button">Desfavoritar</Tooltip>}>
                            <figure>
                              <FaHeart size={22} className="cart-icon" />
                            </figure>
                          </OverlayTrigger>
                        ) : (
                          <OverlayTrigger placement="top" overlay={<Tooltip id="favorite-button">Favoritar</Tooltip>}>
                            <figure>
                              <FaRegHeart size={22} className="cart-icon" />
                            </figure>
                          </OverlayTrigger>
                        )}
                      </button>
                      <Dropdown>
                        <Dropdown.Toggle as={Button} className="btn btn-primary">
                          <figure className="m-0">
                            <img className="cart-icon" src={Share} alt="" />
                          </figure>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => {
                              const url = window.location.href
                              navigator.clipboard.writeText(url)
                              SweetAlert.fire({
                                title: 'Link copiado!',
                                icon: 'success',
                                toast: true,
                                position: 'top-end',
                                showConfirmButton: false,
                                timer: 3000
                              })
                            }}
                          >
                            Copiar link
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => {
                              const url = window.location.href
                              const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(url)}`
                              window.open(whatsappUrl, '_blank')
                            }}
                          >
                            Compartilhar no WhatsApp
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                      <OverlayTrigger placement="top" overlay={<Tooltip id="tt-export-pdf">Baixar perfil em PDF</Tooltip>}>
                        <button className="btn btn-primary" onClick={handleExportPdf}>
                          <figure>
                            <FaFilePdf size="22" className="cart-icon" />
                          </figure>
                        </button>
                      </OverlayTrigger>
                      {laudoGeneticoDoc && (
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tt-laudo-genetico">Ver laudo genético</Tooltip>}>
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => setPdfLightbox({ url: laudoGeneticoDoc.file, title: 'Laudo Genético' })}
                          >
                            <figure>
                              <FaDna size="22" className="cart-icon" />
                            </figure>
                          </button>
                        </OverlayTrigger>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {donor.proseed_description ? (
            <div className="donator-impress mb-4">
              <h5>Impressões da equipe do Banco de Sêmen sobre o doador</h5>
              <div className="row mt-3">
                <div className="col-12">
                  <p className="mb-0">
                    {donor.proseed_description}
                  </p>
                </div>
              </div>
            </div>
          ) : null}

          <div className="info-section">
            <div className="tabs">
              <Tabs
                defaultActiveKey="general"
              >
                <Tab eventKey="general" title="Sobre o Doador">
                  <General donor={donor} />
                </Tab>
                <Tab eventKey="features" title="Características Físicas">
                  <Features donor={donor} />
                </Tab>
                {donor.sperm_bank?.name === 'Pro-Seed' && (
                  <Tab eventKey="history" title="Histórico de Saúde & Família">
                    <History donor={donor} />
                  </Tab>
                )}
                <Tab eventKey="exams" title="Triagem Médica & Exames">
                  <Exams donor={donor} />
                </Tab>
                <Tab eventKey="genetics" title="Genética">
                  <Genetics donor={donor} />
                </Tab>
                <Tab eventKey="ask" title="Palavras do Doador">
                  <Ask donor={donor} />
                </Tab>
              </Tabs>
            </div>
          </div>

          {donorSuggestions.length > 0 && (
            <div className="sugestions mb-5">
              <div className="title pb-3">
                <h5>Separamos alguns doadores para você.</h5>
                <p>Confira mais alguns doadores que são parecidos com o da sua busca.</p>
              </div>
              <Slider {...suggestionSliderSettings}>
                {donorSuggestions.map((donorSuggestion: IDonorSuggestion) => (
                  <div key={donorSuggestion.id}>
                    <CardSugestion donor={donorSuggestion} />
                  </div>
                ))}
                {Array.from({ length: donorSuggestions.length }).map((_, index) => (
                  <div key={donorSuggestions[index].id}>
                    <>
                      <CardSugestion donor={donorSuggestions[index]} />
                    </>
                  </div>
                ))}
              </Slider>
            </div>
          )}
        </div>
      </div>

      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        index={lightboxIndex}
        slides={donor.photos?.map(photo => ({ src: photo })) || []}
        plugins={[Thumbnails]}
      />

      {pdfLightbox && (
        <PdfLightbox
          isOpen={!!pdfLightbox}
          fileUrl={pdfLightbox.url}
          title={pdfLightbox.title}
          onClose={() => setPdfLightbox(null)}
        />
      )}

      <CatalogFooter />
    </>
  )
}

export default Donator
